// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import countries from './countries';
import primaryProductStatuses from './primary-product-statuses';
import product from './product';
import statesInCountry from './states-in-country';
import statusChangeRequest from './status-change-request';
import statusChangeRequestForm from './status-change-request-form';

export default {
    statusChange: combineReducers({
        busyCounter,
        countries,
        primaryProductStatuses,
        product,
        statesInCountry,
        statusChangeRequest,
        statusChangeRequestForm
    })
};



// WEBPACK FOOTER //
// ./src/product/status-change-request/reducers/index.js